Ext.define('SA.Listener', {
    constructor({eventSource, eventName}) {
        this.eventSource = eventSource;
        this.eventName = eventName;
    },

    destroy() {
        this.unlisten();
    },

    listen() {
        this.eventSource.on(this.eventName, this.callback);

        this.removeListener = () => this.eventSource.un(this.eventName, this.callback);
    },

    pause() {
        this.unlisten();
    },

    resume() {
        this.listen();
    },

    setCallback(callback) {
        this.callback = callback;
    },

    unlisten() {
        this.removeListener();
    }
});